import(/* webpackMode: "eager" */ "/workspace-install/projects/astrolive-app/app/(astro routes)/occult/[subPage]/page.tsx")